import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import { Icon } from 'common/components';
import { DOWNLOAD_TEMPLATE_TEXT } from 'common/config/app.config';
import { downloadTemplateActions } from 'common/redux/download-template';
import { downloadIcon } from 'assets/media/icons/custom';

import './DownloadTemplate.scss';

type DownloadTemplateProps = {
    fromMaster?: boolean;
};

const DownloadTemplate: FC<DownloadTemplateProps> = ({ fromMaster }) => {
    const dispatch = useDispatch();

    const handleDownload = () => {
        dispatch(downloadTemplateActions.downloadFile());
    };
    return (
        <div className={`download-icon-container ${fromMaster ? 'master-download' : ''}`}>
            <span className="download-icon-container inner-container" onClick={handleDownload}>
                <Icon src={downloadIcon} className="download-icon"></Icon>
                {DOWNLOAD_TEMPLATE_TEXT}
            </span>
        </div>
    );
};

export default DownloadTemplate;
